import { useEffect, useState, type CSSProperties } from 'react';

// Legacy compositions still used by the areas being ported by track C.
export const wrap: CSSProperties = { minWidth: 0, maxWidth: '100%', overflowWrap: 'anywhere', whiteSpace: 'normal' };
export const flow: CSSProperties = { ...wrap, display: 'flex', flexWrap: 'wrap', gap: 'var(--gap)', alignItems: 'center' };
export const stack: CSSProperties = { ...wrap, display: 'grid', gridTemplateColumns: 'minmax(0, 1fr)', gap: 'var(--pad-y)' };
export const row: CSSProperties = { ...flow, padding: 'var(--pad-y) var(--pad-x)', minHeight: 'var(--tap)', background: 'var(--surface)' };
export const note: CSSProperties = { margin: 0, color: 'var(--muted)', fontSize: 'var(--t-meta)' };
export const link: CSSProperties = { ...wrap, color: 'inherit', fontWeight: 600, minHeight: 'var(--tap)', display: 'inline-flex', alignItems: 'center' };
export const control: CSSProperties = { ...wrap, height: 'auto', minHeight: 'var(--opt-h)', textAlign: 'left' };
export function usePhone(): boolean {
  const [phone, setPhone] = useState(() => window.innerWidth < 760);
  useEffect(() => {
    const resize = () => setPhone(window.innerWidth < 760);
    window.addEventListener('resize', resize);
    return () => window.removeEventListener('resize', resize);
  }, []);
  return phone;
}

/** Counts in the drawings are live values, including the singular form. */
export const peopleCount = (n: number) => `${n} ${n === 1 ? 'person' : 'people'}`;
export const displayWords = (words: string) => words.replace(/\b1 people\b/g, '1 person');
